import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Create,
  TextInput,
  Edit,
  Delete,
  Filter,
  EditButton,
  TabbedForm,
  FormTab,
  BooleanField,
  BooleanInput,
  ReferenceInput,
  SelectInput
} from 'admin-on-rest/lib/mui';

import Gallery from './gallery';
import LinkToRelatedProducts from './LinkToRelatedProducts';
import CustomImageField from '../custom/imageSize';

const DestinationFilter = (props) => (
  <Filter {...props}>
    <TextInput label="resources.name.name" source="name" alwaysOn/>
  </Filter>
);

export const CompaniesList = (props) => (
  <List {...props}  filters={<DestinationFilter />} title="resources.management_companies.name">
    <Datagrid>
    <CustomImageField width={200} height={125} source="gallery[0]" label="resources.image.name" />
      <TextField label="resources.name.name" source="name" />
      <BooleanField label="resources.pay_quiz.name" source="quiz_box_paid" />
      <LinkToRelatedProducts />
      <EditButton />
    </Datagrid>
  </List>
);

export const CreateCompany = (props) => (
  <Create {...props}>
  <TabbedForm redirect="list">
      <FormTab label="general" >
      <TextInput label="resources.name.name" source="name" />
      <TextInput source="email" />
      <TextInput label="resources.password.name" source="password" />
      <BooleanInput label="resources.pay_quiz.name" source="quiz_box_paid" />
      <ReferenceInput
            label="categories"
            source="type"
            reference="categories"
            allowEmpty
            perPage={1000}
          >
            <SelectInput optionText={choice => `${choice.title}`} />
          </ReferenceInput>
        </FormTab>
      <FormTab label="photos">
        <Gallery source="gallery" />
        </FormTab>
          </TabbedForm>
  </Create>
);

const PostTitle = ({ record }) => {
    return <span>{record ? `${record.name}` : ''}</span>;
};

export const EditCompany = (props) => (
  <Edit title={<PostTitle />} {...props}>
    <TabbedForm >
        <FormTab label="general">
        <TextInput label="resources.name.name" source="name" />
        <ReferenceInput
            label="categories"
            source="type"
            reference="categories"
            allowEmpty
            perPage={1000}
          >
            <SelectInput optionText={choice => `${choice.title}`} />
          </ReferenceInput>
        <TextInput label="New password" source="newpassword" />
        <TextInput label="Repeat new password" source="repassword" />
        <BooleanInput label="resources.pay_quiz.name" source="quiz_box_paid" />
          </FormTab>
        <FormTab label="photos">
          <Gallery source="gallery" />
          </FormTab>
            </TabbedForm>

  </Edit>
);

const DeleteTitle = ({ record }) => {
    return <span>{record ? `Διαγραφή του ${record.title}` : ''}</span>;
};

export const DeleteCompany = (props) => <Delete title={<DeleteTitle />} {...props} />;



// WEBPACK FOOTER //
// ./src/pages/companies/companies.js